let heroLoadedScheduled = false;

function scheduleHeroLoaded() {
  if (heroLoadedScheduled) return;
  heroLoadedScheduled = true;

  setTimeout(function () {
    const heroSection = document.querySelector(".hero-section");
    const heroSliderSec = document.querySelector(".heroSliderSec");

    if (heroSection) {
      heroSection.classList.add("loaded");
    }

    if (heroSliderSec) {
      setTimeout(function () {
        heroSliderSec.classList.add("loaded");
      }, 500);
    }
  }, 2000);
}

function pageLoader(callback) {
  const loader = document.querySelector(".loader-first");
  const html = document.querySelector("html");

  const onLoaderComplete = function () {
    scheduleHeroLoaded();

    if (typeof callback === "function") {
      callback();
    }
  };

  if (!loader) {
    onLoaderComplete();
    return;
  }

  setTimeout(function () {
    loader.classList.add("loader-animate");

    setTimeout(function () {
      loader.classList.add("loader-closed");

      if (html) {
        html.classList.remove("loadjs");
      }

      onLoaderComplete();
    }, 2000);
  }, 200);
}

export default pageLoader;
